<template>
     <div class="sidebar-wrapper sidebar-theme">

            <div id="dismiss" class="d-lg-none"><i class="flaticon-cancel-12"></i></div>


    <nav id="sidebar">

 

                <ul class="list-unstyled menu-categories" id="accordionExample">
                    <li class="menu">

                 <ul class="navbar-nav theme-brand flex-row  d-none d-lg-flex">
                    <li class="nav-item d-flex">
                        <router-link :to="{name: 'dashboard'}" class="navbar-brand">
                            <img :src="settings.image_path" class="img-fluid" alt="logo">
                        </router-link>

                        <p class="border-underline"></p>
                    </li>
                    <li class="nav-item theme-text">
                        <router-link :to="{name: 'dashboard'}" class="nav-link">{{settings.name}}</router-link>
                    </li>
                    
                </ul>
                
                     <ul class="list-unstyled menu-categories" id="accordionExample5">
 
                    <li class="menu">
                        <a class="dropdown-toggle d-flex justify-content-center dashboard-toggle">
                            <div class="mt-2 text-center"><router-link :to="{name: 'dashboard'}">
                                <i class="flaticon-computer-6 dashboard-link"></i>
                                <span>لوحة التحكم</span>
                                </router-link>
                            </div>
                        </a>
                    </li>



                     <li class="menu" v-if="user.role == 'admin'">
                        <a href="#setting" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                            <div class="">
                                <i class="flaticon-setting-1"></i>
                                <span> الإعدادت</span>
                            </div>
                            <div>
                                <i class="flaticon-left-arrow"></i>
                            </div>
                        </a>
                        <ul class="collapse submenu list-unstyled" id="setting" data-parent="#accordionExample">
                           
                        
                            <li v-if="hasPermissions('enterprises_edit')">
                                <router-link :to="{name: 'enterprises.edit', params: {id: 1}}"><i class=""></i> البيانات الأساسية</router-link>
                            </li>

                            <li v-if="hasPermissions('notificationTemplates')">
                                <router-link :to="{name: 'notificationTemplates'}"><i class=""></i> قوالب الاشعارات</router-link>
                            </li>
                            <li v-if="hasPermissions('parentNotifications')">
                                <router-link :to="{name: 'parentNotifications'}"><i class=""></i>  الاشعارات</router-link>
                            </li>

                            <li v-if="hasPermissions('stages')">
                                <router-link :to="{name: 'stages'}"><i class=""></i>إدارة المراحل</router-link>
                            </li>
                            <li v-if="hasPermissions('groups')">
                                <router-link :to="{name: 'groups'}"><i class=""></i>إدارة الصفوف</router-link>
                            </li>

                        </ul>
                    </li>

          <li class="menu">
                        <a href="#setting2" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                            <div class="">
                                <i class="flaticon-user-1"></i>
                                <span> إدارة المستخدمين</span>
                            </div>
                            <div>
                                <i class="flaticon-left-arrow"></i>
                            </div>
                        </a>
                        <ul class="collapse submenu list-unstyled" id="setting2" data-parent="#accordionExample">
                            <li>
                                <router-link :to="{name: 'profile'}"><i class=""></i>الملف الشخصي</router-link>
                            </li>


                                <li v-if="hasPermissions('admins')">
                                <router-link :to="{name: 'admins'}"><i class=""></i> المستخدمين</router-link>
                            </li>
                             <li v-if="hasPermissions('admins')">
                                <router-link :to="{name: 'roles'}"><i class=""></i> إدارة الصلاحيات</router-link>
                            </li>

                        </ul>
                    </li>


                     <li class="menu" v-if="hasPermissions('lessons') || hasPermissions('teachers')">
                        <a href="#lessons" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                            <div class="">
                                <i class="flaticon-user-group-2"></i>
                                <span> الحلقات والمعلمين</span>
                            </div>
                            <div>
                                <i class="flaticon-left-arrow"></i>
                            </div>
                        </a>
                        <ul v-if="hasPermissions('lessons') || hasPermissions('teachers')" class="collapse submenu list-unstyled" id="lessons" data-parent="#accordionExample">
          

                          <li v-if="hasPermissions('lessons')">
                                <router-link :to="{name: 'lessons'}"><i class=""></i>إدارة الحلقات</router-link>
                            </li>

                            <li v-if="hasPermissions('teachers')">
                                <router-link :to="{name: 'teachers'}"><i class=""></i>إدارة المعلمين</router-link>
                            </li>


                        </ul>
                    </li>

                     <li class="menu" v-if="hasPermissions('parents') || hasPermissions('interviews') || hasPermissions('students')">
                        <a href="#students" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">

                            <div class="">
                                <i class="flaticon-user-8"></i>
                                <span> إدارة الطلاب  </span>
                            </div>
                            <div>
                                <i class="flaticon-left-arrow"></i>
                            </div>
                        </a>
                        <ul v-if="hasPermissions('parents') || hasPermissions('interviews') || hasPermissions('students')" class="collapse submenu list-unstyled" id="students" data-parent="#accordionExample">
          
                            <li v-if="hasPermissions('parents')">
                                <router-link :to="{name: 'parents'}"><i class=""></i>اولياء الامور </router-link>
                            </li>
                            <li v-if="hasPermissions('interviews')">
                                <router-link :to="{name: 'interviews'}"><i class=""></i>المقابلات الشخصية</router-link>
                            </li>
                            <li v-if="hasPermissions('students')">
                                <router-link :to="{name: 'students'}"><i class=""></i>الطلاب المقبولين</router-link>
                            </li>
                            <li v-if="hasPermissions('vouchers')">
                                <router-link :to="{name: 'students.fees.index'}"><i class=""></i>رسوم الطلاب</router-link>
                            </li>

                            <!-- <li v-if="hasPermissions('events')">
                                <router-link :to="{name: 'events'}"><i class=""></i>  إدارة الاحداث</router-link>
                            </li>
 -->
                            
                        </ul>
                    </li>

                <ul class="submenu list-unstyled show">

                            
                            <li v-if="hasPermissions('absences')">
                                <router-link :to="{name: 'absences'}"><i class="flaticon-file"></i> الحضور والغياب</router-link>
                            </li>

                            <li v-if="hasPermissions('saveReviewPlans')">
                                <router-link :to="{name: 'saveReviewPlans'}"><i class="flaticon-file"></i> خطة الحفظ و المراجعة</router-link>
                            </li>


                            <li v-if="hasPermissions('saveReviews')">
                                <router-link :to="{name: 'saveReviews'}"><i class="flaticon-file"></i> الحفظ و المراجعة</router-link>
                            </li>

                            <li v-if="hasPermissions('addDegrees')">
                                <router-link :to="{name: 'addDegrees'}"><i class="flaticon-user-check"></i> درجات التميز</router-link>
                            </li>
                             <li v-if="hasPermissions('attendDegrees')">
                                <router-link :to="{name: 'attendDegrees'}"><i class="flaticon-view-2"></i>  السلوك والمواظبة</router-link>
                            </li>

                  </ul>
                        <li class="menu" v-if="hasPermissions('activeDegrees') || hasPermissions('items') || hasPermissions('budgets') || hasPermissions('budgets_confirm') || hasPermissions('activities') || hasPermissions('activities_confirm') || hasPermissions('vouchers')">
                        <a href="#activities" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                            <div class="">
                                <i class="flaticon-file"></i>
                                <span> البرامج والأنشطة </span>
                            </div>
                            <div>
                                <i class="flaticon-left-arrow"></i>
                            </div>
                        </a>
                        <ul v-if="hasPermissions('activeDegrees') || hasPermissions('items') || hasPermissions('budgets') || hasPermissions('budgets_confirm') || hasPermissions('activities') || hasPermissions('activities_confirm') || hasPermissions('vouchers')"  class="collapse submenu list-unstyled" id="activities" data-parent="#accordionExample">
          
<!-- 
                              <li v-if="hasPermissions('activeDegrees')">
                                <router-link :to="{name: 'activeDegrees'}"><i class=""></i> درجات النشاط</router-link>
                            </li> -->
                            <li v-if="hasPermissions('items')">
                                <router-link :to="{name: 'items'}"><i class=""></i>البنود </router-link>
                            </li>
                            <li v-if="hasPermissions('budgets')">
                                <router-link :to="{name: 'budgets'}"><i class=""></i>ميزانية البرنامج </router-link>
                            </li>
                            <li v-if="hasPermissions('budgets_confirm')">
                                <router-link :to="{name: 'budgetsConfirm'}"><i class=""></i>تقرير ميزانية البرنامج </router-link>
                            </li>
                            <li v-if="hasPermissions('activities')">
                                <router-link :to="{name: 'activities'}"><i class=""></i> إدارة الانشطة </router-link>
                            </li>

                             <li v-if="hasPermissions('activities_confirm')">
                                <router-link :to="{name: 'activitiesConfirm'}"><i class=""></i>تقرير الانشطة </router-link>
                            </li>
                            <li v-if="hasPermissions('vouchers')">
                                <router-link :to="{name: 'vouchers'}"><i class=""></i> السندات </router-link>
                            </li>


                        </ul>
                    </li> 

                    <li class="menu" v-if="hasPermissions('reports')" >
                        <a href="#reports" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                            <div class="">
                                <i class="flaticon-file"></i>
                                <span> التقارير </span>
                            </div>
                            <div>
                                <i class="flaticon-left-arrow"></i>
                            </div>
                        </a>
                        <ul v-if="hasPermissions('reports')" class="collapse submenu list-unstyled" id="reports" data-parent="#accordionExample">
          

                            <li v-if="hasPermissions('reports') && user.role == 'admin'">
                                <router-link :to="{name: 'reports.absences'}"><i class=""></i>  تقرير التردد اليومى</router-link>
                            </li>
                            
                            <li v-if="hasPermissions('reports') && user.role == 'admin'">
                                <router-link :to="{name: 'reports.review'}"><i class=""></i>  تقرير التحضير والادخال</router-link>
                            </li>

                            <li v-if="hasPermissions('reports')">
                                <router-link :to="{name: 'reports.studentDegrees'}"><i class=""></i>  تقرير  الطالب</router-link>
                            </li>
                            <li v-if="hasPermissions('reports')">
                                <router-link :to="{name: 'reports.lessonAbsences'}"><i class=""></i>  تقرير  الحضور والغياب</router-link>
                            </li>
                            <li v-if="hasPermissions('reports') && user.role == 'admin'">
                                <router-link :to="{name: 'reports.absences_day'}"><i class=""></i>  تقرير  الحضور والغياب لليوم</router-link>
                            </li>
                            <li v-if="hasPermissions('reports') && user.role == 'admin'">
                                <router-link :to="{name: 'reports.saveReview'}"><i class=""></i>تقرير الطلاب لم يحفظوا </router-link>
                            </li>
                            <li v-if="hasPermissions('reports') && user.role == 'admin'">
                                <router-link :to="{name: 'reports.weekDegree'}"><i class=""></i>  تقرير فارس الاسبوع</router-link>
                            </li>
                            <li v-if="hasPermissions('reports') && user.role == 'admin'">
                                <router-link :to="{name: 'reports.totalStudentDegree'}"><i class=""></i>  تقرير الطالب الاجمالى</router-link>
                            </li>
                            <li v-if="hasPermissions('reports')">
                                <router-link :to="{name: 'report.notifications'}"><i class=""></i>  تقرير الاشعارات</router-link>
                            </li>


                        </ul>
                    </li> 


                <ul class="submenu list-unstyled show">
               


                            <li v-if="hasPermissions('requests') && user.role != 'admin'">
                                <router-link :to="{name: 'requests'}"><i class="flaticon-usre-8"></i>طلبات انضمام ابنائي </router-link>
                            </li>
                             <li v-if="hasPermissions('notifications') && user.role != 'admin'">
                                <router-link :to="{name: 'notifications'}"><i class="flaticon-copy"></i> الاشعارات </router-link>
                            </li>

                            
                            <li v-if="user.role == 'parent'">
                                <router-link :to="{name: 'my-students'}"><i class="flaticon-copy"></i> بيانات طلابى </router-link>
                            </li>
<!-- 
                            <li v-if="hasPermissions('parent-events') && user.role == 'parent'">
                                <router-link :to="{name: 'parent-events'}"><i class="flaticon-copy"></i> الاحداث </router-link>
                            </li> -->
                        </ul>
                 
                </ul>
            </li>


 
            </ul>
            </nav>


        </div>
</template>

<script>
import baseApi from '@/baseApi'
import { mapGetters } from 'vuex'
export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    ...mapGetters({
      settings: 'GET_WEBSITE_SETTING_KEYS'
    })
  },
  data() {
    return {
    };
  },
  methods: {
    
  }
};
</script>
